/* @flow */

import { Info } from 'luxon';

/**
 * Load a polyfill for timezones if necessary. If a polyfill is not required,
 * the promise resolves instantly. Check Luxon's documentation for more details.
 * This function assumes that `loadJS` is attached to the window Object.
 *
 * Ref: https://moment.github.io/luxon/docs/manual/matrix.html
 * @returns {Promise} Promise
 */
export function polyfillTimezones(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (Info.features().zones) {
      resolve();
    } else {
      const script = window.loadJS(
        'https://unpkg.com/date-time-format-timezone@latest/build/browserified/date-time-format-timezone-complete-min.js',
        resolve,
      );

      script.onerror = reject;
    }
  });
}
